import { isStepEmpty } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/ReturnInstructions/ReturnInstructionDetailConfiguration/AddReturnSteps/helpers'

export const getReturnInstructions = (instructions, supportedLanguages) => {
  const returnInstructions = Object.fromEntries(supportedLanguages.map(key => [key, []]))
  if (instructions) {
    const maxSteps = Math.max(...Object.values(instructions).map(steps => steps?.length || 0), 0)
    const sharedIds = Array.from({ length: maxSteps }, () => Math.random())

    Object.keys(instructions).forEach(key => {
      if (supportedLanguages.includes(key)) {
        returnInstructions[key] = (instructions[key] || []).map((text, i) => ({ id: sharedIds[i], text }))
      }
    })

    supportedLanguages.forEach(key => {
      const padding = sharedIds.slice(returnInstructions[key].length).map(id => ({ id, text: '' }))
      returnInstructions[key] = [...returnInstructions[key], ...padding]
    })
  }
  return returnInstructions
}

export const normalizeSteps = steps => {
  if (!steps) return {}

  const languages = Object.keys(steps)

  const getEmptyIndices = () => {
    return steps[languages[0]].map((_, i) => i).filter(i => languages.every(lang => isStepEmpty(steps[lang][i])))
  }

  const getFilteredSteps = emptyIndices => {
    return Object.fromEntries(
      languages.map(lang => [lang, steps[lang].filter((_, i) => !emptyIndices.includes(i)).map(step => step.text)])
    )
  }

  return getFilteredSteps(getEmptyIndices())
}

export const hasCompletedSteps = (steps, languages) => {
  if (!languages?.length) return false

  const maxSteps = Math.max(0, ...languages.map(lang => steps[lang]?.length || 0))
  if (maxSteps === 0) return false

  return languages.every(lang => {
    const langSteps = steps[lang] || []

    return langSteps.length >= maxSteps && langSteps.every(step => !isStepEmpty(step))
  })
}

export const addStepToAllLanguages = (steps, languages) => {
  const sharedId = Math.random()
  const newStep = { id: sharedId, text: '' }

  return Object.fromEntries(languages.map(lang => [lang, [...(steps[lang] || []), newStep]]))
}

export const removeStepFromAllLanguages = (steps, languages, stepId) => {
  return Object.fromEntries(languages.map(lang => [lang, steps[lang]?.filter(step => step.id !== stepId)]))
}

export const updateStepText = (steps, language, stepId, value) => {
  const newSteps = steps[language]?.map(step => {
    return step.id === stepId ? { ...step, text: value } : step
  })

  return { ...steps, [language]: newSteps }
}
